module.exports = __webpack_public_path__ + "webauthn_ico@2x.84cdfbb5cf59540c4d36f9a51a330751.png";